import React from 'react';
import SectionHeading from '../shared/SectionHeading';
import ReviewCard from '../shared/ReviewCard';
import verifiedReviews, { REVIEW_SUMMARY } from '../../data/reviews';
import SecondaryButton from '../shared/SecondaryButton';
import { GOOGLE_REVIEWS_URL } from '../../data/companyProfiles';
import { SUPPORT_CTA_TEXT } from '../../data/contact';

const ReviewsSection = () => (
  <section className="section section-surface">
    <div className="container">
      <SectionHeading
        eyebrow="Customer Feedback"
        title={`${REVIEW_SUMMARY.rating} stars across ${REVIEW_SUMMARY.count} Google reviews.`}
        description={`These short excerpts link to public review profiles. Review total last verified ${REVIEW_SUMMARY.lastVerified}.`}
      />
      <div className="responsive-grid responsive-grid-3">
        {verifiedReviews.map((review) => (
          <ReviewCard key={`${review.name}-${review.sourceLabel}`} {...review} />
        ))}
      </div>
      <div className="section-actions">
        <SecondaryButton
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {SUPPORT_CTA_TEXT}
        </SecondaryButton>
      </div>
    </div>
  </section>
);

export default ReviewsSection;
